<template>
	<div class="flex flex-col">
		<app-title-bar :icon="['fas', 'fa-route']" title="Journey Planner">
			<div class="flex items-center gap-3">
				<app-button
					theme="outline"
					:icon="app.fullscreen ? 'fa-minimize' : 'fa-maximize'"
					@click="app.toggleFullscreen()">
					{{ app.fullscreen ? 'Exit full screen' : 'Full screen' }}
				</app-button>

				<depots-dropdown v-if="depots" v-model="depots" multiple :min="1" />
			</div>
		</app-title-bar>

		<journey-planner v-if="depots" :depots="depots" />
	</div>
</template>

<script lang="ts" setup>
	import { ref, onMounted } from 'vue'
	import DepotsDropdown from '@/components/partials/dropdowns/DepotsDropdown.vue'
	import JourneyPlanner from '@/components/partials/JourneyPlanner.vue'
	import useAuthStore from '@/stores/auth'
	import useAppStore from '@/stores/app'

	const auth = useAuthStore()
	const app = useAppStore()
	const depots = ref()

	onMounted(() => {
		if (auth.user && auth.user.current_depot) {
			depots.value = [auth.user.current_depot]
		}
	})
</script>
